/* eslint-disable max-len */
import type { ChakraComponent } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/react'
import React from 'react'

export const WarningIcon: ChakraComponent<'svg', any> = (props) => (
  <chakra.svg
    width={'24px'}
    height={'24px'}
    viewBox={'0 0 24 24'}
    fill={'none'}
    {...props}
  >
    <path
      fillRule={'evenodd'}
      clipRule={'evenodd'}
      d={'M9.90847 3.71861C10.826 2.08745 13.1745 2.08745 14.092 3.71861L20.7884 15.6233C21.6883 17.2231 20.5322 19.1999 18.6966 19.1999H5.30388C3.4683 19.1999 2.31219 17.2231 3.2121 15.6233L9.90847 3.71861ZM13.2001 15.6C13.2001 16.2628 12.6629 16.8 12.0001 16.8C11.3374 16.8 10.8001 16.2628 10.8001 15.6C10.8001 14.9373 11.3374 14.4 12.0001 14.4C12.6629 14.4 13.2001 14.9373 13.2001 15.6ZM12.0001 6.00002C11.3374 6.00002 10.8001 6.53728 10.8001 7.20002V10.8C10.8001 11.4628 11.3374 12 12.0001 12C12.6629 12 13.2001 11.4628 13.2001 10.8V7.20002C13.2001 6.53728 12.6629 6.00002 12.0001 6.00002Z'}
      fill={'#FF9D00'}
    />
  </chakra.svg>
)
